<div class="page-container">
    <app-header title="performance.review-index.title" [menuService]="performanceMenuService">
        <div class="buttons">
            <ui-button
                (click)="trackCreatingReview()"
                type="primary"
                *permission="createPermission"
                [routerLink]="!isPerformanceImprovementsFeatureFlagEnabled ? ['create'] : ['create-bulk']"
            >
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'performance.overview.createReview' | translate }}
            </ui-button>
        </div>
    </app-header>

    <app-table [table]="table">
        <app-empty-state label="performance.overview.noReviewsFound" src="/assets/illustrations/clipboard-star.png">
        </app-empty-state>
    </app-table>
</div>
